export function getCurrentTimeZoneIANA() {
    // 使用Intl.DateTimeFormat来获取时区信息 返回IANA时区标识符
    const resolvedOptions = Intl.DateTimeFormat()?.resolvedOptions()
    // console.log({resolvedOptions})
    return resolvedOptions?.timeZone;
}